import {BadgeRequestCategoryEnum} from '@employee-models/data.enums';

export const PHOTO_REQUIRED_VISITOR_CATEGORIES: BadgeRequestCategoryEnum[] = [
    BadgeRequestCategoryEnum.NonDeloitte,
    BadgeRequestCategoryEnum.MemberFirm,
    BadgeRequestCategoryEnum.ThirdPartyContractor
];

export function isPhotoRequiredCategory(categoryId: BadgeRequestCategoryEnum): boolean {
    return PHOTO_REQUIRED_VISITOR_CATEGORIES.includes(categoryId);
}
